import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function WindowInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Window function</FieldLabel>
      <Select value={c.fn || 'row_number'} onChange={(v) => u({ fn: v })}
        options={['row_number', 'rank', 'dense_rank', 'lag', 'lead', 'running_sum'].map(v => ({ value: v, label: v }))} />
      <FieldLabel>Partition by</FieldLabel>
      <MultiCols selected={c.partition || []} onChange={(v) => u({ partition: v })} />
      <FieldLabel>Order by</FieldLabel>
      <ColSelect value={c.orderBy} onChange={(v) => u({ orderBy: v })} />
      <FieldLabel>Output column</FieldLabel>
      <TextInput mono value={c.target} onChange={(v) => u({ target: v })} placeholder="rank" />
      {c.fn === 'running_sum' && (
        <DecimalPlacesField defaultPlaces={null} value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
      )}
    </div>
  );
}
